import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {schoolUiTexts} from 'data/ui-texts';
import {renderMarkdown} from 'helpers/text-helper';
import {soundsData} from 'data/sound-data';
import {scenariosData} from 'data/scenarios-data';
import Button from 'components/ui/button/button';
import Logo from 'components/ui/logo/logo';
import QRCode from 'components/ui/qr-code/qr-code';
import './game-evaluation.scss';
import appConfig from 'config/app.config';

const GameEvaluation = (props) => {
	const {scenarioId, game, schoolData, handleGoToPage, updateBackground, handlePlayMusic, updateGame} = props;
	
	/* Get QR url */
	const scenarioData = scenariosData[scenarioId];
	let qrUrl = scenarioData.defaultQrUrl;
	if (schoolData && schoolData.scenarioQrUrls) {
		const scenarioQrUrl = schoolData.scenarioQrUrls.find((s) => {return s.scenarioId === scenarioId;});
		if (scenarioQrUrl && scenarioQrUrl.qrUrl) {
			qrUrl = scenarioQrUrl.qrUrl;
		}
	}
	if (qrUrl.indexOf('http://') === 0) {
		qrUrl = qrUrl.replace('http://', 'https://');
	}
	if (qrUrl.indexOf('https://') !== 0) {
		qrUrl = 'https://' + qrUrl;	
	}

	/* Get text */
	const scenarioUrl = scenarioData.gameUrl ? scenarioData.gameUrl : appConfig.gameUrl + '/' + scenarioData.url;
	const text = JSON.parse(JSON.stringify(schoolUiTexts.evaluationPage.text))
		.replace('%url%', scenarioUrl)
		.replace('%gameCode%', '<span>' + game.id + '</span>');

	// Navigates back to landing page and stops the music
	const handleGoBack = () => {
		handlePlayMusic(false, null);
		updateGame({status: 'done'}).catch((error) => {
			console.error(error);
		});
	};

	useEffect(() => {
		// Set background image id
		updateBackground('school', scenarioId);

		const audioName = scenarioId + 'Music';
		handlePlayMusic(false, soundsData[audioName]);
		
		return () => {
			handlePlayMusic(false, null);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);	

	return (
		<div className="GameEvaluation">
			{/* Logo */}
			<div className="GameEvaluation-logo" onClick={() => {handleGoToPage('landing');}} >
				<Logo scenarioId={scenarioId} />
			</div>

			<div className="GameEvaluation-qrCodeWrap">
				<div className="GameEvaluation-qrCodeText">
					{renderMarkdown(text)}
				</div>
				<div className="GameEvaluation-qrCodeImage">
					<QRCode url={qrUrl} />
				</div>
				<div className="GameEvaluation-qrCodeUrl">
					<span>{qrUrl}</span>
				</div>
			</div>

			{/* Back to landing page btn */}
			<div className="GameEvaluation-backBtn2">
				<Button 
					classes={['blueLight', scenarioId, 'backBtn']}
					text={schoolUiTexts.back}
					onClick={() => {handleGoBack();}}
				/>
			</div>

			{/* Go to control panel btn */}
			<div className="GameEvaluation-controlPanelBtn">
				<Button 
					classes={['blueLight', game.scenarioId, 'responsive']}
					text={schoolUiTexts.goToControlPanel}
					onClick={() => {handleGoToPage('control-panel');}}
				/>
			</div>
		</div>
	);
};

GameEvaluation.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	game: PropTypes.object.isRequired,
	schoolData: PropTypes.object.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired,	
	handlePlayMusic: PropTypes.func.isRequired,
	updateGame: PropTypes.func.isRequired
};

export default GameEvaluation;
